module.exports = __webpack_public_path__ + "img/icon-map-pin.d05c6157.svg";